/**
     * @desc 驾驶员分页列表
where查询条件
     */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.TheDriverManagementQueryParameters>): Promise<BaseResponse<defs.PageBean<Array<defs.ThePilotListManagementReturnObjects>>>> {
  return fetch({
    url: config.API_HOST + '/mall/driver/queryDriverInfoList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
